"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _actionUtils = require("../../utils/actionUtils");
/**
 * This stages a featured presenter.
 * The idea is to handle which presenter source is featured without any side effects
 */

function stageFeaturedPresenter(presenterId) {
  return (0, _actionUtils.actionCreator)(_types.BROADCAST_SET_FEATURED_PRESENTER, {
    presenterId: presenterId
  });
}
var _default = exports["default"] = stageFeaturedPresenter;